import "jquery.fancytree";


    /**
     * Variable tree builder
     */
export class VariableTree {


    // var tree = null;
    private eventObservable = null;
    tree: Fancytree.Fancytree = null;


    /**
     * Draws the tree
     */
    drawTree = (treeData,
        allowMultiSelect,
        targetDiv: JQuery,
        eventObservableObj,
        onActivateHandler,
        nodeDeactivateHandler,
        afterChangeHandler,
        selectionChangeHandler): Fancytree.Fancytree => {

        // Attach the dynatree widget to an existing <div id="tree"> element
        // and pass the tree options as an argument to the dynatree() function:

        this.eventObservable = eventObservableObj;

        var selectMode = allowMultiSelect ? 2 : 1;

        var sourceData = treeData;

//;new Array<any>();
        //          for

//treeData[0], treeData[1]);
        //sourceData.push(treeData[0]);

        var options: Fancytree.FancytreeOptions = {
            activate: onActivateHandler,
            deactivate: nodeDeactivateHandler,
            //autoFocus: true,
            //persist: true, 
            autoCollapse: false,
            source: sourceData,
            //onKeydown: thiskeyDownHandler,
            selectMode: selectMode,
            checkbox: allowMultiSelect,
            select: selectionChangeHandler
        }

        if (this.tree) {
            this.tree.reload(sourceData);
        } else {
            $(targetDiv)
                .fancytree(options);
            this.tree = $(targetDiv).fancytree("getTree");
        }
        return this.tree;
    }

}




// WEBPACK FOOTER //
// ./ClientApp/scripts/ah.mb.ui.variable-tree.ts